import React, { useEffect, useState } from 'react';
import RatingBox from './RatingBox';

const getInitials = (name) => (name || '')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((word) => word[0])
  .join('')
  .toUpperCase();

const logoClass = 'h-16 w-16 shrink-0 rounded-2xl bg-white shadow-md ring-1 ring-black/5 sm:h-[72px] sm:w-[72px]';

const Header = ({
  companyName,reviewCount,ratingValue,
  headerTextColor,logo, headerColor,
}) => {
  // Fall back to company initials when the logo is missing or fails to load
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    setLogoFailed(false);
  }, [logo]);

  return (
    <div
      className="flex w-full items-center justify-center gap-4 px-6 py-6 sm:justify-start sm:px-10"
      style={{ backgroundColor: headerColor }}
    >
      {logo && !logoFailed && (
        <img
          src={logo}
          alt="logo"
          className={`${logoClass} object-contain p-1`}
          onError={() => setLogoFailed(true)}
        />
      )}
      {(!logo || logoFailed) && companyName && (
        <div className={`${logoClass} flex items-center justify-center text-xl font-medium text-slate-600`}>
          {getInitials(companyName)}
        </div>
      )}
      <div className="min-w-0">
        <div
          className="truncate text-base font-semibold tracking-tight sm:text-lg"
          style={{ color: headerTextColor }}
        >
          {companyName}
        </div>

        {ratingValue !== null && (
          <div className="mt-1.5 flex items-center gap-2">
            <div className="flex items-center rounded-full bg-[#1976d2] py-0.5 pl-2.5 pr-2 text-xs font-medium text-white shadow-sm">
              <div className="pb-[1px]">
                {Number(ratingValue)}
              </div>

              <RatingBox value={Number(ratingValue)} />
            </div>

            <div
              className="text-[13px] underline underline-offset-2 opacity-90"
              style={{ color: headerTextColor }}
            >
              {reviewCount}
              {' '}
              reviews
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
